// extracted by mini-css-extract-plugin
module.exports = {"content":"contacts_content__aD4FJ","contacts_link":"contacts_contacts_link__3bOXb","icon":"contacts_icon__39AKv"};